import {AutoComplete, DatePicker, Form, Input, InputNumber, Select} from "antd";
import {FormInstance} from "antd/lib/form/Form";
import React, {useContext, useEffect, useMemo, useRef, useState} from "react";
import type {InputRef} from "antd";
import {FIELD_TYPE, FORMAT_TIME, LOAI_PHIEU_KHO} from "types/enums";
import dayjs from "dayjs";
import {useAppSelector} from "redux/hooks";
import {pharmacyStoreService, catalogService, storeService} from "api";
import moment from "moment";
import {
  formatToCurrencyTypeToFixed,
  isValuableString,
  randomId,
  toNumber,
} from "helper/common";

import {Rule} from "antd/es/form";
import Notification from "components/common/notification/notification";
import {number} from "yup";
type EditableRowProps = {
  index: number;
};
const {INPUT, SELECT, NUMBER, DATE, AUTO_COMPLETE, COMBO_BOX, CURRENCY, CODE} =
  FIELD_TYPE;
export type EditableCellProps = {
  title: React.ReactNode;
  editable?: boolean;
  children: React.ReactNode;
  dataIndex: any;
  record: any;
  selected: boolean;
  options: any;
  name: string;
  index: number;
  type: FIELD_TYPE;
  disabled?: boolean;
  value?: any;
  onChange?: (e) => void;
  handleSave: (record, index) => void;
  onFocus?: () => void;
  onPressEnter?: (e) => void;
  addonAfter?: any;
  initRules?: Rule[];
  hidden?: boolean;
  autoFocus?: boolean;
  form?: any;
  setTongTien?: any;
};

export const EditableContext = React.createContext<FormInstance<any> | null>(
  null
);

export const EditableRow: React.FC<EditableRowProps> = ({index, ...props}) => {
  return (
    <>
      <tr {...props} />
    </>
  );
};

export const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  selected,
  options,
  handleSave,
  name,
  index,
  type,
  onChange,
  onPressEnter,
  disabled,
  value,
  hidden,
  form,
  autoFocus,
  setTongTien,
  initRules,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);
  const [newOptions, setNewOptions] = useState(options);
  const [listSearchMedicine, setListSearchMedicine] = useState<any[]>([]);

  const [tiLeUnit, setTiLeUnit] = useState(1);
  const [currentLo, setCurrentLo] = useState(null);
  const [currentMedicine, setCurrentMedicine] = useState();
  const khoXuatId = useAppSelector(state => state.tableAdd.khoXuatId);
  const khoNhapId = useAppSelector(state => state.tableAdd.khoNhapId);
  const typePhieu = useAppSelector(state => state.pharmacyStore.typePhieu);
  const [max, setMax] = useState(null);
  const [rules, setRules] = useState<Rule[]>(initRules);
  const [tonKho, setTonKho] = useState<Number>(0);
  const [donGiaNhap, setDonGiaNhap] = useState<any>(0);
  const [openDropdown, setOpenDropdown] = useState<boolean>(false);
  const setFieldValue = (dataIndex: string, value: any) => {
    form?.setFieldValue([name, index, dataIndex], value);
  };
  const getFieldValue = (dataIndex: string) => {
    return form?.getFieldValue([name, index, dataIndex]);
  };
  useEffect(() => {
    if (record) {
      setMaxOfCell();
      setRulesOfCell();
      setDonGiaNhap(record?.donGiaNhap);
      setTongTienThuoc(record);
      setTonKho(toNumber(record?.tonKho));
      setFieldValue("vat", toNumber(record?.vat));
    }
    setListUnit();
    setListBaoChe();
    setListDuocChinh();

    // setTongTienThuoc();
  }, []);

  useEffect(() => {
    if (
      (dataIndex == "soLo" ||
        dataIndex == "tenThuoc" ||
        dataIndex == "thuocId") &&
      currentLo &&
      khoXuatId != null &&
      (typePhieu == LOAI_PHIEU_KHO.XUAT || typePhieu == LOAI_PHIEU_KHO.DU_TRU)
    ) {
      setValueByLo(currentLo, khoXuatId);
    }
    if (
      dataIndex == "soLo" &&
      currentLo &&
      khoNhapId != null &&
      typePhieu == LOAI_PHIEU_KHO.NHAP
    ) {
      setValueByLo(currentLo, khoNhapId);
    }
  }, [currentLo]);
  useEffect(() => {
    if (currentMedicine) {
      setValueByMedicine(currentMedicine);
    }
  }, [currentMedicine]);
  const setCurrentLoByMedicine = async tenThuoc => {
    if (tenThuoc) {
      let listLo = await getListLoInStoreByParams();
      const listLoExisted = form
        .getFieldValue("listReceiptDetailDto")
        ?.map(e => e?.soLo);
      const listLoReduce = listLo?.filter(
        e => !listLoExisted?.includes(e?.soLo)
      );
      setCurrentLo(listLoReduce?.[0]?.soLo);
      setFieldValue("soLo", listLoReduce?.[0]?.soLo);
    }
  };
  const setValueByMedicine = currentMedicine => {
    setFieldValue(
      "thuocId",
      currentMedicine?.id != null ? currentMedicine?.id.toString() : null
    );
    const hasQuyetDinhThau = currentMedicine?.bidDecision?.decision;
    console.log(currentMedicine);
    console.log(listSearchMedicine);

    const name = hasQuyetDinhThau
      ? `${currentMedicine.name} - ${currentMedicine?.bidDecision?.decision}`.trim()
      : currentMedicine?.name;
    setFieldValue("tenThuoc", name);
    setFieldValue("baoCheId", currentMedicine?.baoCheId);
    setFieldValue("duocChinhId", currentMedicine?.duocChinhId);
    setFieldValue("hoatChat", currentMedicine?.hoatChat);
    setFieldValue("donGiaXuat", currentMedicine?.donGiaBan);
    setFieldValue("donGiaNhap", currentMedicine?.donGiaNhap);
    setFieldValue("donViTinhId", currentMedicine?.donViTinhId);
    setFieldValue("soLoNCC", currentMedicine?.soLoNCC);
    setFieldValue("baoQuan", currentMedicine?.baoQuan);
    setFieldValue("decision", currentMedicine?.bidDecision?.decision);
    setCurrentLoByMedicine(currentMedicine?.name);
  };
  useEffect(() => {
    if (typePhieu == LOAI_PHIEU_KHO.NHAP) {
      if (dataIndex == "createDate") {
        setFieldValue("createDate", dayjs());
      }
    }
  }, [typePhieu]);

  const setValueByLo = async (soLo, khoId) => {
    var detailLo = await getDetailLo(soLo, khoId);

    setFieldValue(
      "thuocId",
      detailLo.thuocId != null ? detailLo.thuocId.toString() : null
    );
    console.log(detailLo?.tenThuoc);
    setFieldValue("tenThuoc", detailLo?.tenThuoc);
    setFieldValue("hanSuDung", moment(detailLo?.ngayHetHan));
    setFieldValue("tonKho", detailLo?.tonKho);
    setFieldValue("donGiaNhap", detailLo?.donGiaNhap);
    setFieldValue("donGiaXuat", detailLo?.donGiaXuat);
    setFieldValue("ngayNhap", detailLo?.ngayNhap);
    setFieldValue("baoCheId", detailLo?.baoCheId);
    setFieldValue("duocChinhId", detailLo?.duocChinhId);
    setFieldValue("baoQuan", detailLo?.baoQuan);
    setFieldValue("vat", detailLo?.vat);
    setFieldValue("hoatChat", detailLo?.hoatChat);
    setFieldValue("soLoNCC", detailLo?.soLoNCC);
    setFieldValue("nhomThuoc", detailLo?.nhomThuoc);
    setFieldValue("nuocSanXuat", detailLo?.nuocSanXuat);
    setFieldValue("nhaCungCap", detailLo?.nhaCungCap);
    setFieldValue("donViTinhId", detailLo?.donViTinhId);
    setFieldValue(
      "ngaySanXuat",
      detailLo?.ngaySanXuat ? moment(detailLo?.ngaySanXuat) : null
    );
    setFieldValue(
      "ngayHetHan",
      detailLo?.ngayHetHan ? moment(detailLo.ngayHetHan) : null
    );
    if (typePhieu == LOAI_PHIEU_KHO.XUAT) {
      setFieldValue(
        "ngayNhap",
        detailLo?.ngayNhap ? moment(detailLo?.ngayNhap) : null
      );
      setFieldValue("donGiaXuat", detailLo?.donGiaXuat);
    }
    // await getListUnitByMedicineId(detailLo?.thuocId);
    setTongTienThuoc();
    setTonKho(detailLo?.tonKho);
    setDonGiaNhap(detailLo?.donGiaNhap);
    handleChangeDonViTinh(detailLo?.donViTinhId);
  };
  const setListUnit = async () => {
    if (dataIndex == "donViTinhId") {
      const res = await getListUnit();
      const listUnit = res?.data;
      setNewOptions(
        listUnit.map(e => ({key: randomId(), value: e.id, label: e.name}))
      );
    }
  };
  const setListBaoChe = async () => {
    if (dataIndex == "baoCheId") {
      const res = await getListBaoChe();
      const listBaoChe = res;
      setNewOptions(listBaoChe.map(e => ({value: e.id, label: e.name})));
    }
  };
  const setListDuocChinh = async () => {
    if (dataIndex == "duocChinhId") {
      const res = await getListDuocChinh();
      const listDuocChinh = res;
      setNewOptions(listDuocChinh.map(e => ({value: e.id, label: e.name})));
    }
  };
  const setMaxOfCell = () => {
    if (dataIndex == "vat") {
      setMax(100);
    }
  };
  const setRulesOfCell = () => {
    // if (dataIndex == "thuocId") {
    //   setRules([{required: true, message: "Chưa có mã thuốc"}]);
    // }
  };
  const handleChangeDonViTinh = async donViTinhId => {
    const thuocId = getFieldValue("thuocId");
    let listUnit: any = null;

    if (thuocId != null) {
      const res = await getListUnitByThuocId(thuocId);
      listUnit = res;
    } else {
      const res = await getListUnit();
      listUnit = res.data;
    }
    const donVi = listUnit.find(e => e.id == donViTinhId);
    const tiLe = donVi?.tiLe ?? 1;
    const phepTinh = donVi?.phepTinh ?? "Nhân";
    const tiLeThuc = phepTinh == "Nhân" ? Number(tiLe) : Number(1 / tiLe);
    setTiLeUnit(tiLeThuc);
  };
  useEffect(() => {
    if (dataIndex == "donViTinhId" || dataIndex == "soLo") {
      const soLuongTonMoi = Number(tonKho) * tiLeUnit;
      const donGiaNhapMoi = Number(donGiaNhap) / tiLeUnit;
      setFieldValue("tonKho", toNumber(soLuongTonMoi));
      setFieldValue("donGiaNhap", !isNaN(donGiaNhapMoi) ? donGiaNhapMoi : null);
    }
  }, [tiLeUnit, tonKho, donGiaNhap]);

  const getDetailLo = async (soLo, khoId) => {
    try {
      const res = await pharmacyStoreService.getDetailLo(soLo, khoId);

      return res;
    } catch (error) {
      Notification("error", "Đã có lỗi khi lấy thông tin của số lô vừa nhập");
      return null;
    }
  };

  const getListLoInStoreByParams = async () => {
    let params: any = {
      tenThuoc: getFieldValue("tenThuoc"),
    };
    if (
      typePhieu == LOAI_PHIEU_KHO.XUAT ||
      typePhieu == LOAI_PHIEU_KHO.DU_TRU
    ) {
      if (khoXuatId == null) {
        Notification("warning", "Chọn kho xuất để lấy thông tin lô trong kho");
        return [];
      } else {
        params = {...params, khoId: khoXuatId};
        try {
          const res = await storeService.getListLoInStoreByParams(params);
          if (res.length == 0) {
            Notification(
              "info",
              "Không có lô thuốc nào ở kho xuất thỏa mãn các tham số đã chọn"
            );
          }

          return res?.filter(e =>
            isValuableString(getFieldValue("tenThuoc"))
              ? e?.tenThuoc == getFieldValue("tenThuoc")
              : true
          );
        } catch (error) {
          console.log(error);
          return [];
        }
      }
    }
    // if (typePhieu == LOAI_PHIEU_KHO.NHAP) {
    //   if (khoNhapId == null) {
    //     Notification("warning", "Chọn kho nhập để lấy thông tin lô trong kho");
    //     return [];
    //   } else {
    //     params = {...params, khoId: khoXuatId};
    //     try {
    //       const res = await storeService.getListLoInStoreByParams(params);
    //       if (res.length == 0) {
    //         Notification(
    //           "info",
    //           "Không có lô thuốc nào ở kho nhập thỏa mãn các tham số đã chọn"
    //         );
    //       }
    //       return res;
    //     } catch (error) {
    //       return [];
    //     }
    //   }
    // }
  };
  const getListUnit = async () => {
    try {
      const res = await catalogService.getListUnit();
      return res;
    } catch (error) {
      return [];
    }
  };
  const getListUnitByThuocId = async id => {
    try {
      const res = await pharmacyStoreService.getListUnitByThuocId(id);
      return res;
    } catch (error) {
      return [];
    }
  };

  const setListMedicineByParams = async () => {
    let params: any = {
      tenThuoc: getFieldValue("tenThuoc"),
      donViTinhId: getFieldValue("donViTinhId"),
      baoCheId: getFieldValue("baoCheId"),
      duocChinhId: getFieldValue("duocChinhId"),
      // hoatChatId: getFieldValue('hoatChatId')
    };
    let listMedicine: any[] = [];
    if (typePhieu == LOAI_PHIEU_KHO.NHAP) {
      const res = await storeService.getListMedicineByQDThau(params);

      listMedicine = res?.data || [];
      listMedicine = listMedicine.map(e => {
        const hasQuyetDinhThau = e?.quyetDinhThau;
        const nameLabel = hasQuyetDinhThau
          ? `${e.tenThuoc} - ${e.quyetDinhThau}`.trim()
          : e?.tenThuoc;
        return {
          ...e,
          name: nameLabel,
          id: e?.idThuoc,
        };
      });
      setListSearchMedicine(listMedicine);
    }
    if (
      typePhieu == LOAI_PHIEU_KHO.XUAT ||
      typePhieu == LOAI_PHIEU_KHO.DU_TRU
    ) {
      if (khoXuatId == null) {
        Notification(
          "warning",
          "Chọn kho xuất để lấy thông tin thuốc trong kho"
        );
      } else {
        params = {
          ...params,
          ngaySanXuat: getFieldValue("ngaySanXuat"),
          ngayHetHan: getFieldValue("ngayHetHan"),
          khoId: khoXuatId,
        };
        const res = await storeService.getListMedicineInStoreByParams(params);

        listMedicine = res;
        setListSearchMedicine(res);
      }
    }
    if (dataIndex == "thuocId") {
      setNewOptions(
        listMedicine.map(e => ({value: e.id, label: e.id, key: e.id}))
      );
    }
    if (dataIndex === "tenThuoc") {
      console.log(listMedicine);
      setNewOptions(
        listMedicine.map(e => {
          return {
            value: e.name,
            label: e.name,
            key: e.id,
          };
        })
      );
    }
  };
  const getDetailMedicineById = async (id, khoId = null) => {
    try {
      const res = await pharmacyStoreService.getPharmacy(id, khoId);
      return res;
    } catch (error) {
      return null;
    }
  };
  const getListBaoChe = async () => {
    try {
      const res = await storeService.getListBaoChe();
      return res;
    } catch (error) {
      return [];
    }
  };
  const getListDuocChinh = async () => {
    try {
      const res = await storeService.getListDuocChinh();
      return res;
    } catch (error) {
      return [];
    }
  };

  const setTongTienThuoc = (record = null) => {
    const soLuongNhap = record
      ? record?.soLuongNhap
      : getFieldValue("soLuongNhap");
    const donGia = record ? record?.donGiaNhap : getFieldValue("donGiaNhap");
    const vat = record ? record?.vat : getFieldValue("vat");
    console.log(donGia);
    const thanhTien = soLuongNhap * donGia;
    const tongTien = (thanhTien * (100 + vat)) / 100;
    setFieldValue("thanhTien", toNumber(thanhTien));
    setFieldValue("tongTien", toNumber(tongTien));
    console.log(tongTien);
    setTongTien(getTongTienDon());
  };
  const getTongTienDon = () => {
    const formTable = form.getFieldValue(name) || [];
    let tongGiaTriDon = 0;
    formTable.forEach(e => {
      tongGiaTriDon += toNumber(e?.tongTien);
    });
    return tongGiaTriDon;
  };
  const getListThau = async () => {
    const params = {
      medicineId: getFieldValue("thuocId"),
      medicineName: getFieldValue("tenThuoc"),
    };
    try {
      const res =
        (await pharmacyStoreService.getListBidDecisionByMedicineParams(
          params
        )) || [];
      setNewOptions(
        res.map(e => ({
          value: e?.bidDecision?.decision,
          label: e?.bidDecision?.decision,
        }))
      );
    } catch (error) {}
  };
  useEffect(() => {
    inputRef.current?.focus();
  }, [editing]);

  let childNode = children;

  if (type == INPUT) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
        rules={rules}
      >
        <Input
          placeholder={disabled ? "--" : "Nhập"}
          disabled={disabled}
          onClick={() => {}}
          onChange={async e => {}}
        ></Input>
      </Form.Item>
    );
  }
  if (type == DATE) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={null}
        rules={rules}
      >
        <DatePicker
          disabled={disabled}
          onChange={() => {}}
          format={FORMAT_TIME.dayFull.toString()}
        ></DatePicker>
      </Form.Item>
    );
  }
  if (type == NUMBER) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
        rules={rules}
      >
        <InputNumber
          disabled={disabled}
          onChange={e => {
            if (dataIndex == "soLuongNhap" || dataIndex == "vat") {
              setTongTienThuoc();
            }
          }}
          onClick={e => {
            // if (
            //   dataIndex == "soLuongNhap" &&
            //   typePhieu == LOAI_PHIEU_KHO.XUAT
            // ) {
            //   console.log(getFieldValue("tonKho"));
            //   console.log(e);
            //   setRules([
            //     {
            //       max: getFieldValue("tonKho"),
            //       type: "number",
            //       message: "Đã vượt quá số lượng tồn kho",
            //     },
            //   ]);
            // }
          }}
          placeholder={disabled ? "--" : "Nhập"}
          max={max}
          min={0}
          controls={false}
          {...restProps}
        ></InputNumber>
      </Form.Item>
    );
  }
  if (type == AUTO_COMPLETE) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
        rules={rules}
      >
        <AutoComplete
          showSearch
          autoFocus={autoFocus}
          allowClear
          placeholder={disabled ? "--" : "Chọn"}
          notFoundContent={null}
          value={value}
          defaultActiveFirstOption={false}
          filterOption={(inputValue, option) =>
            option?.label
              ?.toString()
              .toUpperCase()
              .indexOf(inputValue.toUpperCase()) !== -1
          }
          open={openDropdown}
          onFocus={() => {
            setOpenDropdown(true);
          }}
          onBlur={() => {
            setOpenDropdown(false);
          }}
          onSelect={() => {
            setOpenDropdown(false);
          }}
          onClick={async e => {
            if (openDropdown == false) {
              setOpenDropdown(true);
            }
            if (dataIndex == "thuocId" || dataIndex == "tenThuoc") {
              setListMedicineByParams();
            }
            if (dataIndex == "soLo") {
              const listLo = await getListLoInStoreByParams();
              const listLoExisted = form
                .getFieldValue("listReceiptDetailDto")
                ?.map(e => e?.soLo);
              const listLoReduce = listLo?.filter(
                e => !listLoExisted?.includes(e?.soLo)
              );

              setNewOptions(
                listLoReduce.map(e => ({value: e.soLo, label: e.soLo}))
              );
            }
          }}
          options={newOptions}
          disabled={disabled}
          onClear={() => {}}
          onChange={async e => {
            if (dataIndex == "soLo") {
              setCurrentLo(e);
              // setFieldValue("tenThuoc", null);
              setFieldValue("hanSuDung", null);
              setFieldValue("ngaySanXuat", null);
              setFieldValue("baoCheId", null);
              setFieldValue("duocChinhId", null);
              setFieldValue("thuocId", null);
              setFieldValue("ngayHetHan", null);
              setFieldValue("donGiaNhap", null);
              setFieldValue("donGiaXuat", null);
              setFieldValue("tonKho", null);
              setFieldValue("soLuongNhap", null);
              setFieldValue("vat", 0);
              setFieldValue("hoatChat", null);
              setFieldValue("nuocSanXuat", null);
              setFieldValue("nhaCungCap", null);
              setFieldValue("donViTinhId", null);
            }
            if (dataIndex == "thuocId") {
              const detailMedicine = await getDetailMedicineById(e, khoNhapId);
              setCurrentMedicine(detailMedicine);
              setCurrentLo(null);
              setFieldValue("soLo", null);
              setFieldValue("tenThuoc", null);
              setFieldValue("hanSuDung", null);
              setFieldValue("ngaySanXuat", null);
              setFieldValue("baoCheId", null);
              setFieldValue("duocChinhId", null);
              setFieldValue("ngayHetHan", null);
              setFieldValue("donGiaNhap", null);
              setFieldValue("donGiaXuat", null);
              setFieldValue("soLuongNhap", null);
              setFieldValue("vat", 0);
              setFieldValue("hoatChat", null);
              setFieldValue("nuocSanXuat", null);
              setFieldValue("nhaCungCap", null);
              setFieldValue("donViTinhId", null);
            }

            if (dataIndex == "tenThuoc") {
              const selectedThuocId = listSearchMedicine.find(
                medicine => medicine.name == e
              )?.id;

              const detailMedicine = await getDetailMedicineById(
                selectedThuocId,
                khoNhapId
              );
              console.log(newOptions);
              setCurrentMedicine(detailMedicine);
              setListMedicineByParams();
              setCurrentLo(null);
              setFieldValue("soLo", null);
              setFieldValue("thuocId", null);
              setFieldValue("hanSuDung", null);
              setFieldValue("baoCheId", null);
              setFieldValue("duocChinhId", null);
              setFieldValue("ngaySanXuat", null);
              setFieldValue("ngayHetHan", null);
              setFieldValue("donGiaNhap", null);
              setFieldValue("donGiaXuat", null);
              setFieldValue("soLuongNhap", null);
              setFieldValue("vat", 0);
              setFieldValue("hoatChat", null);
              setFieldValue("nuocSanXuat", null);
              setFieldValue("nhaCungCap", null);
              setFieldValue("donViTinhId", null);
            }

            // lay list so lo
          }}
          {...restProps}
        ></AutoComplete>
      </Form.Item>
    );
  }
  if (type == COMBO_BOX) {
    childNode = (
      <Form.Item
        style={{margin: 0}}
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
      >
        <Select
          showSearch
          style={{
            width: "100%",
          }}
          filterOption={(input, option) =>
            (option?.label.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          open={openDropdown}
          onFocus={() => {
            setOpenDropdown(true);
          }}
          onBlur={() => {
            setOpenDropdown(false);
          }}
          onSelect={() => {
            setOpenDropdown(false);
          }}
          placeholder={disabled ? "--" : "Chọn"}
          options={newOptions}
          disabled={disabled}
          allowClear={true}
          onChange={e => {
            handleChangeDonViTinh(e);
          }}
          onClick={async e => {
            if (openDropdown == false) {
              setOpenDropdown(true);
            }
            if (dataIndex == "donViTinhId") {
              const thuocId = getFieldValue("thuocId");
              let listUnit: any = null;
              if (typePhieu == LOAI_PHIEU_KHO.XUAT) {
                var detailLo = await getDetailLo(
                  getFieldValue("soLo"),
                  khoXuatId
                );
                setTonKho(detailLo?.tonKho);
                setDonGiaNhap(detailLo?.donGiaNhap);
              }

              if (thuocId) {
                const res = await getListUnitByThuocId(thuocId);
                listUnit = res;
              } else {
                const res = await getListUnit();
                listUnit = res.data;
              }
              setNewOptions(listUnit.map(e => ({value: e.id, label: e.name})));
            }
            if (dataIndex == "decision") {
              getListThau();
            }
          }}
          {...restProps}
        />
      </Form.Item>
    );
  }

  if (type == CURRENCY) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
      >
        <InputNumber
          disabled={disabled}
          defaultValue={value}
          formatter={value => formatToCurrencyTypeToFixed(value, 4)}
          parser={value => value!.replace(/\$\s?|(,*)/g, "")}
          onChange={e => {
            if (dataIndex == "donGiaNhap") {
              setTongTienThuoc();
              console.log(e);
              console.log(typeof e);
            }
          }}
          placeholder={!disabled ? "Nhập" : ""}
          addonAfter="VNĐ"
          stringMode
          controls={false}
          min={0}
          {...restProps}
        />
      </Form.Item>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
